import React, { useEffect, useRef, useState } from "react";

import { Select } from "@chakra-ui/react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

import { useAppDispatch, useAppSelector } from "store/store";
import { actions } from "store/user/reducer";

interface IProps {
	value?: [number, number];
}

const accessToken = "pk.eyJ1IjoiZGh1YiIsImEiOiJjbGUyczIyODQwMXdrM3dseG53MnMxaXI4In0.FYGuulRoBvKZ56vsbIXpzA";

const getStyleUrl = (style: string) => {
	switch (style) {
		case "satellite":
			return "mapbox://styles/dhub/cmpy98lzk000y01sihwomavex";
		default:
			return "mapbox://styles/dhub/cl2ypoavr000z14n5af53rj77";
	}
};

export const Mapbox: React.FC<IProps> = (props) => {
	const { value } = props;
	const mapContainerRef = useRef<HTMLDivElement>(null);
	const mapRef = useRef<mapboxgl.Map | null>(null);
	const markerRef = useRef<mapboxgl.Marker | null>(null);
	const mapStyle = useAppSelector((state) => state.user.mapStyle);
	const dispatch = useAppDispatch();
	const [expanded, setExpanded] = useState(false);

	useEffect(() => {
		setTimeout(() => mapRef.current?.resize(), 50);
	}, [expanded]);

	useEffect(() => {
		if (!mapContainerRef.current) return;

		const map = new mapboxgl.Map({
			container: mapContainerRef.current,
			style: getStyleUrl(mapStyle),
			accessToken,
			center: [(value && value[0]) || -3, (value && value[1]) || 40],
			zoom: value ? 7 : 3,
		});

		mapRef.current = map;

		if (value) {
			markerRef.current = new mapboxgl.Marker({ color: "#718096", scale: 0.6 }).setLngLat(value).addTo(map);
		}

		return () => {
			map.remove();
			mapRef.current = null;
			markerRef.current = null;
		};
	}, []);

	useEffect(() => {
		mapRef.current?.setStyle(getStyleUrl(mapStyle));
	}, [mapStyle]);

	useEffect(() => {
		if (!mapRef.current) return;
		if (value) {
			if (markerRef.current) {
				markerRef.current.setLngLat(value);
			} else {
				markerRef.current = new mapboxgl.Marker({ color: "#718096", scale: 0.6 })
					.setLngLat(value)
					.addTo(mapRef.current);
			}
		} else if (markerRef.current) {
			markerRef.current.remove();
			markerRef.current = null;
		}
	}, [value]);

	return (
		<div>
			{!expanded && (
				<Select value={mapStyle} my=".5rem" onChange={(e) => dispatch(actions.setStyle(e.target.value))}>
					<option value="default">Vista mapa</option>
					<option value="satellite">Vista satélite</option>
				</Select>
			)}
			<div
				style={
					expanded
						? { position: "fixed", top: "3rem", left: 0, right: 0, bottom: 0, zIndex: 100, background: "white" }
						: { position: "relative" }
				}
			>
				{expanded && (
					<div style={{ position: "absolute", top: "0.5rem", left: "0.5rem", zIndex: 2, width: "10rem" }}>
						<Select value={mapStyle} size="sm" onChange={(e) => dispatch(actions.setStyle(e.target.value))}>
							<option value="default">Vista mapa</option>
							<option value="satellite">Vista satélite</option>
						</Select>
					</div>
				)}
				<div
					ref={mapContainerRef}
					style={{
						width: "100%",
						height: expanded ? "100%" : "23rem",
						borderRadius: expanded ? 0 : "0.375rem",
					}}
				/>
				<button
					onClick={() => setExpanded((e) => !e)}
					title={expanded ? "Reducir mapa" : "Ampliar mapa"}
					style={{
						position: "absolute",
						top: "0.5rem",
						right: "0.5rem",
						background: "white",
						border: "none",
						borderRadius: "4px",
						padding: "5px",
						cursor: "pointer",
						boxShadow: "0 0 0 2px rgba(0,0,0,0.1)",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						zIndex: 2,
					}}
				>
					{expanded ? (
						<svg width="18" height="18" viewBox="0 0 24 24">
							<path fill="currentColor" d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z" />
						</svg>
					) : (
						<svg width="18" height="18" viewBox="0 0 24 24">
							<path fill="currentColor" d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" />
						</svg>
					)}
				</button>
			</div>
		</div>
	);
};
